export const NotFoundPageDataLoader = async () => {
  throw new Response('Not found', { status: 404 });
};
